import { _js } from '@ifixit/localize';
import { Modal } from 'Shared/modal';
import { MediaTarget } from 'Shared/FrameModules/MediaLibrary/target';
import { Utils } from 'Shared/utils';
import { Auth } from 'Shared/auth';
import { StatusPanel } from 'Shared/status_panel';
import { EditorManager } from 'Shared/editor_manager';
import { StatusNotice } from 'Shared/status_notice';
import TreeEditor from 'Guide/tree_editor';
import { KeyboardNavigation } from 'Shared/keyboard_navigation';
import { CookieUtils } from 'Shared/cookies/cookie-utils';
import trackInPiwikAndGA from 'Shared/Analytics/CombinedGAPiwik';
import { safeSessionStorage } from '@ifixit/utils';

///////////////////////////////////////////////////////////////////////////////
// INIT

onDomReady(() => {
   // If there was a conflict always allow the user to save.
   let onModified;
   let saveBtn = $('saveStep');

   $$('.edit-title-link').addEvent('click', function (ev) {
      this.getParent('.step-title').hide();
      $('editStepTitle').show('inline-block');
      $('editStepTitleInput').focus();
   });

   if ($('currentStepView')) {
      saveBtn.enable();
      onModified = function () {};
   } else {
      onModified = function (modified) {
         if (modified) {
            saveBtn.enable();
            $$('.step-container .js-copy-step-lines').set('disabled', 'disabled');
         }
      };
   }

   let status = new StatusNotice();
   $$('.statuses').adopt(status.element);
   let errorHandler = function (error) {
      status.error(error.message);
   };

   // The EditorManager managers the other managers!
   let stepEditor = new EditorManager({
      errorHandler: errorHandler,
      modifiedHandler: onModified,
   });

   let titleModifiedHandler = stepEditor.getSetModifiedFunction();

   let handleInput = function (value) {
      let message = value ? value : _js('Add a title');
      let edit = $('editStepTitle');
      let view = edit.getSiblings('.step-title');
      let viewValue = view.getElement('.stepTitleValue');

      viewValue.set('text', message);
      viewValue.set('title', message);

      edit.hide();
      view.show();

      if (value !== App.currentStepTitle) {
         saveBtn.enable();
         titleModifiedHandler();
      }
   };

   when($('editStepTitleInput'), stepTitleInput => {
      stepTitleInput.addEvents({
         focus: function () {
            saveBtn.enable();
         },
         blur: function () {
            handleInput(this.value.trim());
         },
         keydown: function (ev) {
            if (ev.key == 'enter' || ev.key == 'esc') {
               handleInput(this.value.trim());
            }
         },
      });
   });

   const validateRange = function () {
      const startTimestampInput = $('editStartTimestampInput');
      const endTimestampInput = $('editEndTimestampInput');
      const startTimestampAsNumber = Number(startTimestampInput?.value.trim());
      const endTimestampAsNumber = Number(endTimestampInput?.value.trim());
      if (
         startTimestampInput?.value.trim() != '' &&
         endTimestampInput?.value.trim() != '' &&
         !Number.isNaN(startTimestampAsNumber) &&
         !Number.isNaN(endTimestampAsNumber) &&
         startTimestampAsNumber >= endTimestampAsNumber
      ) {
         startTimestampInput?.setCustomValidity(
            _js('Start timestamp must be less than end timestamp.')
         );
      } else if (startTimestampInput?.value.trim() == '' && endTimestampInput?.value.trim() != '') {
         startTimestampInput?.setCustomValidity(_js('Start timestamp is required.'));
      } else if (startTimestampInput?.value.trim() != '' && endTimestampInput?.value.trim() == '') {
         endTimestampInput?.setCustomValidity(_js('End timestamp is required.'));
      } else {
         startTimestampInput?.setCustomValidity('');
         endTimestampInput?.setCustomValidity('');
      }
   };

   // Keep track of whether the timestamp input field is different from initial values
   let startTimestampChanged = false;
   const initialStartTimestamp = $('editStartTimestampInput')?.value.trim();
   when($('editStartTimestampInput'), startTimestampInput => {
      startTimestampInput.addEvents({
         focus: function () {
            validateRange();
            saveBtn.enable();
         },
         change: function () {
            validateRange();
            startTimestampChanged = startTimestampInput.value.trim() !== initialStartTimestamp;
            saveBtn.enable();
         },
      });
   });

   let endTimestampChanged = false;
   const initialEndTimestamp = $('editEndTimestampInput')?.value.trim();
   when($('editEndTimestampInput'), endTimestampInput => {
      endTimestampInput.addEvents({
         focus: function () {
            validateRange();
            saveBtn.enable();
         },
         change: function () {
            validateRange();
            endTimestampChanged = endTimestampInput.value.trim() !== initialStartTimestamp;
            saveBtn.enable();
         },
      });
   });

   // If another edit has occurred, allow for this to be saved.
   when($('confirmOverride'), el => {
      saveBtn.enable();
   });

   let treeEditor = new TreeEditor($('stepLines'), stepEditor);

   let apiFailureHandler = function (xhr, message) {
      if (xhr.status === 409) {
         new Request.AjaxIO('getStepConflict', {
            onSuccess: function (stepConflict) {
               $('stepStatusDiv').set('html', stepConflict.statusHtml);
               // We don't support this feature yet for steptranslations.
               if (!App.stepApi.isTranslate) {
                  $('stepConflictDiv').set('html', stepConflict.stepHtml);
                  App.stepApi.path = stepConflict.patchPath;
               }

               StatusPanel.deactivate();
            }.bind(this),
         }).send(App.stepApi.stepid);
      } else {
         let stepStatusDiv = $('stepStatusDiv');
         let notice = new StatusNotice();
         notice.error(message);
         stepStatusDiv.adopt(notice.element);

         stepStatusDiv.scrollIntoView({ behavior: 'smooth' });

         StatusPanel.deactivate();
      }

      saveBtn.enable();
   };

   let clickedSave = false;
   $('guideStepForm').addEvent('submit', ev => {
      clickedSave = true;
      ev.stop();

      let stepStatusDiv = $('stepStatusDiv');
      while (stepStatusDiv?.firstChild) {
         stepStatusDiv.firstChild.remove();
      }

      let statusSuccessDiv = $$('.status.statusSuccess');
      statusSuccessDiv?.destroy();

      let form = $('guideStepForm');
      stepEditor.save(() => {
         Auth.required({
            from: saveBtn,
            message: _js('Log in to save this step.'),
            onAuthorize: function () {
               // Disable the Save button after submitting.
               saveBtn.disable();

               StatusPanel.loading(_js('Saving...'), 100);

               new Request.API_2_0(App.stepApi.path, {
                  method: App.stepApi.method,
                  onSuccess: function (response) {
                     let stepid;

                     // eslint-disable-next-line unicorn/prefer-ternary
                     if (App.stepApi.orderby) {
                        // Step creation responds with the full guide. Also,
                        // orderby is 1-indexed but the array isn't.
                        stepid = response.steps[App.stepApi.orderby - 1].stepid;
                     } else {
                        stepid = response.stepid;
                     }

                     const firedEventsArray = safeSessionStorage.getJson('firedEvents') || [];
                     if (
                        safeSessionStorage.getItem('newGuideId') == App.stepApi.guideid &&
                        !firedEventsArray.includes(stepid)
                     ) {
                        trackInPiwikAndGA({
                           eventCategory: 'Create a Guide Steps',
                           eventAction: 'Create a Guide Step - "Guide Steps" - Complete',
                        });
                        firedEventsArray.push(stepid);
                        safeSessionStorage.setJson('firedEvents', firedEventsArray);
                     }

                     CookieUtils.set('step_state', 'SAVED', {
                        maxAgeInSeconds: 2,
                     });

                     if (App.stepApi.isTranslate) {
                        StatusPanel.deactivate();
                        StatusPanel.notify(_js('Saved successfully.'));
                     } else {
                        window.location = App.stepApi.baseStepEditPath + stepid;
                     }
                  }.bind(this),
                  onFailure: apiFailureHandler,
               }).send(getFormValues());
            },
         });
      });
   });

   when($('deleteStep'), a => {
      a.addEvent('click', ev => {
         ev.stop();

         let confirmMessage =
            _js('Are you sure you want to delete this step?') +
            '\n' +
            _js('Any attached comments will also be removed.');

         if (confirm(confirmMessage)) {
            Auth.required({
               from: $('deleteStep'),
               message: _js('Log in to delete this step.'),
               onAuthorize: function () {
                  StatusPanel.loading(_js('Deleting...'), 100);

                  new Request.API_2_0(App.stepApi.path, {
                     method: 'DELETE',
                     onSuccess: function (response) {
                        window.location = App.stepApi.guideEditPath;
                     },
                     onFailure: apiFailureHandler,
                  }).send();
               },
            });
         }
      });
   });

   // If the editor has modifications on page unload, warn the user.
   Utils.UnsavedChanges.addHandler(() => {
      if (stepEditor.modified && !clickedSave) {
         return _js('You have unsaved modifications. Your changes will be lost if you continue.');
      }
   });

   let stepImageTargets = [];

   when($('stepThumbsList'), stepThumbsList => {
      $$('#stepThumbsList .mediaTarget').each(targetElement => {
         let mediaTarget = MediaTarget.createFromElement(targetElement, {
            customAttach: customMediaTargetAttach,
         });
         stepEditor.watchMediaTarget(mediaTarget);
         stepImageTargets.push(mediaTarget);
      });

      when($('mainGuideImage'), mainGuideImage => {
         let mediaTarget = MediaTarget.createFromElement(mainGuideImage);
         stepEditor.watchMediaTarget(mediaTarget);
      });

      let largeTarget = $$('#bigStepImage > .contents')[0];
      let enlargedTarget = stepImageTargets[0];

      updateLargeImage(enlargedTarget);

      Array.each(stepImageTargets, mediaTarget => {
         let target = mediaTarget.element;
         // When a target is filled in, ensure it gets moved into the Sortables
         // collection.
         mediaTarget.addEvent('itemChanged', (mediaItem, oldMediaItem) => {
            // if we are attaching a media item to the target
            if (mediaItem && !oldMediaItem) {
               $('step-thumbs').grab(target);
               sortableStepImages.addItems(target);
               // if the target becomes empty, move to the empties department
            } else if (!mediaItem && oldMediaItem) {
               $('step-thumb-empties').grab(target);
               sortableStepImages.removeItems(target);
            }

            // If this change even is happening on the target currently displayed
            // in the "large" target, update it.
            if (mediaTarget == enlargedTarget) {
               // If an item is deleted, mediaItem will be null, so we'll
               // default to showing the first MediaTarget.
               let mediaTargetToDisplay = mediaItem ? mediaTarget : stepImageTargets[0];
               updateLargeImage(mediaTargetToDisplay);
            }
         });

         // When hovering over a target, fill the stepImage div with the current
         // image.
         target.addEvent('mouseenter', () => {
            if (mediaTarget.mediaItem) {
               updateLargeImage(mediaTarget);
            }
         });
      });

      /**
       * Update the larger image above the three media targets with the
       * contents of the given mediaTarget.
       */
      function updateLargeImage(mediaTarget) {
         let mediaItem = mediaTarget.mediaItem;
         enlargedTarget = mediaTarget;

         let size = 'standard';
         if (!mediaItem) {
            largeTarget.adopt(MediaTarget.createModifyableIndicator('addImage', size));
            return;
         }

         // When the media Item is finished processing:
         mediaItem.whenReady(() => {
            let display = mediaItem.createDisplay(size);
            // When the image is preloaded
            display.whenReady(() => {
               largeTarget.empty();
               if (currentDisplay) {
                  currentDisplay.dispose();
               }
               let displayElement = display.getElement();
               displayElement.adopt(MediaTarget.createModifyableIndicator('replaceImage', size));
               largeTarget.adopt(displayElement);
               currentDisplay = display;
            });
         });
      }
      let currentDisplay;

      /**
       * Clicking the larger image should be the same as clicking on the target
       * that it is visualizing.
       */
      largeTarget.addEvent('click', () => {
         enlargedTarget.fireEvent('browse');
      });

      // eslint-disable-next-line no-var
      var sortableStepImages = new Sortables('step-thumbs', {
         clone: true,
         opacity: 0.2,
         onSort: stepEditor.getSetModifiedFunction(),
      });
   });

   let mediaTypeButtons = $$('#mediaTypeToggle button');

   let stepObject = $('stepObject');

   if (stepObject) {
      // eslint-disable-next-line no-var
      var objectTarget = MediaTarget.createFromElement(stepObject, {
         iconClass: 'addVideo',
         customAttach: customMediaTargetAttach,
      });

      stepEditor.watchMediaTarget(objectTarget);

      /**
       * Setup the Step Type toggle
       */
      mediaTypeButtons.addEvent('click', function () {
         setStepMediaMode(this.get('data-value'));
      });
   }

   /**
    * Hide or show the approporiate Step Type pane (image / object) and update
    * the media_type form field.
    */
   function setStepMediaMode(mediaType) {
      mediaTypeButtons.each(button => {
         button.toggleClass('active', button.get('data-value') === mediaType);
      });
      let mediaTypeElement = $('stepMediaType'),
         imagesPane = $('stepMediaImages'),
         objectPane = $('stepMediaObject'),
         typeIsImage = mediaType == 'image';

      mediaTypeElement.set('value', mediaType);
      imagesPane.toggleClass('hidden', !typeIsImage);
      objectPane.toggleClass('hidden', typeIsImage);
   }

   /**
    * Attach the item to the target and give it the option to veto the
    * attachment. Checks for, confirms, and accepts placing the wrong type of
    * media on a given target.
    *
    * @param mediaItem the item to attach
    * @param finished(oldItem, success) callback that will be called when the
    *        item has been attached.
    */
   function customMediaTargetAttach(mediaItem, finished) {
      let target = this;
      let itemType = mediaItem && mediaItem.getType();
      let confirmMessage;
      let newStepType;

      // Placing a video or embed on image target
      if (mediaItem && itemType != 'GuideImage') {
         if (target !== objectTarget) {
            confirmMessage = _js(
               'Placing this media will remove any images on this step. Do you want to continue?'
            );
         }
         target = objectTarget;
         newStepType = 'object';

         // Placing image on video target
      } else if (mediaItem && itemType === 'GuideImage' && target === objectTarget) {
         let emptyTarget = stepImageTargets.find(mediaTarget => !mediaTarget.mediaItem);
         if (!emptyTarget) {
            alert(_js('Please change the step type and choose an image to replace.'));
            return finished();
         }
         confirmMessage = _js(
            'Placing this image will clear the media from this step. Do you want to continue?'
         );
         target = emptyTarget;
         newStepType = 'image';
      } else if (mediaItem && mediaItem.data.filter_state() !== true) {
         alert(target.getErrorMessage(mediaItem));
         return finished(mediaItem, false);
      }

      let confirmed = !confirmMessage || confirm(confirmMessage);
      if (confirmed) {
         // eslint-disable-next-line no-var
         var oldItem = target._immediatelyAttach(mediaItem);
         if (newStepType) {
            setStepMediaMode(newStepType);
         }
      }

      if (finished) {
         finished(oldItem, confirmed);
      }
   }

   function getFormValues() {
      let formValues;

      formValues = App.stepApi.isTranslate
         ? {
              title: getTitle(),
              lines: getLines(),
           }
         : {
              title: getTitle(),
              lines: getLines(),
              media: getMedia(),
           };

      if (App.stepApi.orderby) {
         formValues.orderby = App.stepApi.orderby;
      }

      return formValues;
   }

   function getTitle() {
      let titleInput = $('editStepTitleInput');
      return titleInput ? titleInput.get('value') : '';
   }

   function getLines() {
      let lines = [];
      let firstLine = true;
      const isYouTubeGuide = document.querySelectorAll('.stepYouTubeVideo').length > 0;

      treeEditor.lines.each(line => {
         let line_text = line.source;

         if (isYouTubeGuide) {
            // Update the timestamp if it's been changed
            const [startTimestamp, endTimestamp] = getTimestamps();
            const regex = /(.*?)\[(youtubetimestamp)\|(.*?)\|(.*?)](.*)/;
            const match = line_text.match(regex);
            // If there's already an existing timestamp token
            if (match) {
               const [behindText, tokenType, aheadText] = [match[1], match[2], match[5]];
               if (startTimestampChanged || endTimestampChanged) {
                  // If the timestamp field has been cleared, remove any existing timestamp token
                  if (startTimestamp === '' && endTimestamp === '') {
                     line_text = line_text.replace(/\[(youtubetimestamp)\|(.*?)\|(.*?)]/g, '');
                  }
                  // Otherwise, replace the existing timestamp token values with new values
                  // Replace them on the first line only
                  else if (firstLine) {
                     firstLine = false;
                     line_text =
                        behindText +
                        '[' +
                        tokenType +
                        '|' +
                        startTimestamp +
                        '|' +
                        endTimestamp +
                        ']' +
                        aheadText;
                  }
                  // Remove the timestamp from other lines
                  else {
                     line_text = behindText + aheadText;
                  }
               }
               // If timestamp has been manually changed, zero out any negatives
               else {
                  const startTime = match[3].startsWith('-') ? 0 : match[3];
                  const endTime = match[4].startsWith('-') ? 0 : match[4];
                  line_text =
                     behindText +
                     '[' +
                     tokenType +
                     '|' +
                     startTime +
                     '|' +
                     endTime +
                     ']' +
                     aheadText;
               }
            }
            // Otherwise there's no existing timestamp token
            else {
               // If there's a value in the timestamp fields, add a new timestamp token
               if (startTimestamp !== '' && endTimestamp !== '') {
                  line_text = `[youtubetimestamp|${startTimestamp}|${endTimestamp}]` + line_text;
               }
            }
         }
         lines.push({
            text: line_text,
            bullet: line.bullet,
            level: line.level,
         });
      });

      return lines;
   }

   // Get the start and end timestamps from the input fields. If either are negative,
   // return 0 for the negative ones.
   function getTimestamps() {
      let startTimestamp = document.querySelector('#editStartTimestampInput').value;
      let endTimestamp = document.querySelector('#editEndTimestampInput').value;
      const startTime = startTimestamp.startsWith('-') ? 0 : startTimestamp;
      const endTime = endTimestamp.startsWith('-') ? 0 : endTimestamp;

      return [startTime, endTime];
   }

   function getMedia() {
      let mediaType = $('stepMediaType').value.toUpperCase();

      return {
         type: mediaType,
         data: mediaType === 'IMAGE' ? getStepImageData() : getStepObjectData(),
      };
   }

   function getStepImageData() {
      return $('step-thumbs')
         .getElements('input')
         .map(image => image.value.toInt());
   }

   function getStepObjectData() {
      return $('stepObject').getElement('input').value.toInt();
   }

   function handleHelp() {
      if ($$('.modalOpen').length) {
         return;
      }

      Modal.open({
         type: 'element',
         element: $('shortcuts-modal'),
      });
   }

   function handlePreviousStep() {
      window.location = App.previousStepLink;
   }

   function handleNextStep() {
      window.location = App.nextStepLink;
   }

   let keyNav = new KeyboardNavigation({
      keys: {
         'S-;': handleNextStep,
         'S-h': handlePreviousStep,
         'S-/': handleHelp,
      },
   });
});
